/** RFC 4122 v4 UUID; `crypto.randomUUID` where available, `getRandomValues` otherwise (no dependency). */
export function newIdempotencyKey(): string {
  const c = globalThis.crypto;
  if (c?.randomUUID) return c.randomUUID();
  const b = c.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/**
 * One key per distinct submission. The key is stable while the form inputs are unchanged (so a timeout / network
 * retry replays instead of debiting twice) and is regenerated when the inputs change or after a success (a new,
 * intentional withdrawal of the same amount is a new operation).
 */
export class IdempotencyKeyHolder {
  private fingerprint: string | null = null;
  private key: string | null = null;

  keyFor(fingerprint: string): string {
    if (this.key === null || this.fingerprint !== fingerprint) {
      this.fingerprint = fingerprint;
      this.key = newIdempotencyKey();
    }
    return this.key;
  }

  /** Call after a confirmed success. */
  reset(): void {
    this.fingerprint = null;
    this.key = null;
  }
}
